export const ADMIN_USERNAME_MIN_LENGTH = 3;
export const ADMIN_USERNAME_MAX_LENGTH = 32;
export const ADMIN_USERNAME_REGEX = /^[a-z0-9._-]+$/;
